import { render, staticRenderFns } from "./GameItemsEditImage.vue?vue&type=template&id=3550fcb7&scoped=true&"
import script from "./GameItemsEditImage.vue?vue&type=script&lang=js&"
export * from "./GameItemsEditImage.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsEditImage.vue?vue&type=style&index=0&id=3550fcb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550fcb7",
  null
  
)

export default component.exports